import {PIXI} from '@colonist/pixi'

import {UIGameActionButtonPositions} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionsController'
import {UIGameCityImprovement} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGameCityImprovement'
import {UIWGameActionButtonMultiView} from '../ui_game_action/UIWGameActionButtonMultiView'
import {UIWGameCityImprovementProgressTrackerController} from './UIWGameCityImprovementProgressTrackerController'

export class UIWGameCityImprovement extends UIGameCityImprovement {
    protected createCityImprovementProgressTrackerController() {
        new UIWGameCityImprovementProgressTrackerController(this.uiGameManager, this.cityImprovementsState)
    }

    protected createButtonMultiView(buttonContainer: PIXI.Container) {
        this.multiButton = new UIWGameActionButtonMultiView(this.uiGameManager, UIGameActionButtonPositions.CityImprovementMultiButtonWeb, buttonContainer)
    }
}
